import { RouteLocationNormalized } from "vue-router";
import { languagesModule } from "@/store";

const FALLBACK_LANG = "en";

export function getEffectiveLang(route: RouteLocationNormalized): string {
  return languagesModule.getActiveLanguageCode || (route.params.locale as string) || FALLBACK_LANG;
}

export function getDefaultLang(): string {
  const all = languagesModule.getLanguages;
  return all[0]?.code || FALLBACK_LANG;
}

export function isValidLang(code: string): boolean {
  const validCodes = languagesModule.getValidLanguageCodes;
  return validCodes.has(code);
}

export function normalizeLangFromRoute(route: RouteLocationNormalized): string {
  const rawLocale = route.params.locale as string | undefined;
  return isValidLang(rawLocale || "") ? rawLocale! : getDefaultLang();
}

export function isDefaultLang(code: string): boolean {
  return code === getDefaultLang();
}
